'use client'

import { useStore } from '@/lib/store'
import Spinner from '@/shared/components/Spinner'

export default function LoaderContainer() {
  const loading = useStore((state) => state.loading)

  if (!loading) return null

  return (
    <div className="fixed left-0 top-0 z-[9999] flex h-screen w-screen items-center justify-center bg-gray-900/40">
      <Spinner size={10} />
    </div>
  )
}
